import React, { Component } from "react";
import { Route, Routes } from "react-router-dom";
import { connect } from "react-redux";
import routes from "../../routes";
import styled from "styled-components";


// routes config

class DefaultLayout extends Component {
    componentDidMount() {
    }

    render() {
        return (
            <div className="app header-fixed">
                <div className="app-body">
                    <main className="main"
                          style={{ background: "#e4e5e6" }}>
                        <Container>
                            <BackgroundContainer />
                            <Routes>
                                {routes.map((route, idx) => {
                                    return route.component ? (
                                        <Route
                                            key={idx}
                                            path={route.path}
                                            element={<route.component />}
                                        />
                                    ) : null;
                                })}
                            </Routes>
                        </Container>
                    </main>
                </div>
            </div>
        );
    }
}

const Container = styled.div`
    position: absolute;
    height: 100%;
    width: 100%;
    z-index: 1;
`;

const BackgroundContainer = styled.div`
    position: fixed;
    inset: 0;
    z-index: 2;
    background: linear-gradient(to bottom, #EFFBFF 65%, #DBF3FB 65%);
`;

function mapStateToProps(state) {
    const { billing } = state;
    return {
        billing,
    };
}

export default connect(mapStateToProps)(DefaultLayout);